import { render, staticRenderFns } from "./PostButton.vue?vue&type=template&id=09d9e4d5&scoped=true&"
import script from "./PostButton.vue?vue&type=script&lang=js&"
export * from "./PostButton.vue?vue&type=script&lang=js&"
import style0 from "./PostButton.vue?vue&type=style&index=0&id=09d9e4d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9e4d5",
  null
  
)

export default component.exports